import { SelectOption } from '../../../../services/select/interfaces/SelectOption';
import { UnderwriterRole } from '../../enum/UnderwriterRole';

export const underwriterRoleOptions: SelectOption[] = [
  { title: 'Any', value: UnderwriterRole.Any },
  { title: 'Lead Left', value: UnderwriterRole.LeadLeft },
  { title: 'Bookrunner', value: UnderwriterRole.Bookrunner },
  { title: 'Co-manager', value: UnderwriterRole.CoManager },
];
